import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// import { csvtojson } from 'csvtojson';
// import { JSONToCsv } from 'json2csv';

// import { TripsService } from '../../../../../App/src/app/services/trips.service';
import { TripsService } from '@shared/services';
import { ViewBasePage } from '@shared/pages';

@Component({
    'selector': 'app-export',
    'templateUrl': './export.page.html',
    'styleUrls': ['./export.page.scss'],
    'standalone': true,
    'imports': [IonicModule, CommonModule, FormsModule]
})
export class ExportPage extends ViewBasePage implements OnInit, OnDestroy {
    constructor(private tripsService: TripsService,  injector: Injector) {
        super(injector);
    }

    // public async ngOnInit() {
    // }

    // public ngOnDestroy() {
    // }

    // public onImportClick(): void {
    // }

    public async onExportClick(): Promise<void> {
        await this.exportTrips();
    }

    private async exportTrips() {
        const trips = await this.tripsService.getAll();
        this.mydownloadFile(trips);

        // trips.forEach(trip => {

        // });
    }

    private mydownloadFile(data: any) {
        const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
        // const dialogConfig = new MatDialogConfig();

        // dialogConfig.autoFocus = true;
        // dialogConfig.data = {
        const blobUrl = window.URL.createObjectURL(blob);
        //   backupType: 'snippets'
        // };

        // this.backupBookmarksDialog.open(BackupBookmarksDialogComponent, dialogConfig);
        window.open(blobUrl);
    }

    // private downloadFile(data: Snippet[]) {
    //     const blob = new Blob([JSON.stringify(data, null, 2)], {type: 'application/json'});
    //     const dialogConfig = new MatDialogConfig();

    //     dialogConfig.autoFocus = true;
    //     dialogConfig.data = {
    //       blobUrl: window.URL.createObjectURL(blob),
    //       backupType: 'snippets'
    //     };

    //     this.backupBookmarksDialog.open(BackupBookmarksDialogComponent, dialogConfig);
    // }
}
